<template>
  <div
    class="task-run-table-container"
    v-loading="loading"
    element-loading-text="拼命加载中..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.3)"
  >
    <!-- 搜索栏 -->
    <div class="search-bar">
      <!-- 任务编号 下拉框 -->
      <el-select
        v-model="searchParams.task_num"
        placeholder="请选择任务"
        clearable
        style="width: 280px"
      >
        <el-option
          v-for="item in taskList"
          :key="item.task_num"
          :label="`${item.name}`"
          :value="item.task_num"
        />
      </el-select>

      <el-button type="primary" icon="el-icon-search" @click="getRunTaskList">
        搜索
      </el-button>
      <el-button icon="el-icon-refresh" @click="resetSearch"> 重置 </el-button>
    </div>

    <!-- PC 端表格（列宽全部固定，不撑开） -->
    <el-table
    height="900"
      :data="tableData"
      border
      stripe
      style="width: 100%; margin-top: 20px"
      class="pc-table"
    >
      <el-table-column label="ID" prop="id" width="70" align="center" />
      <el-table-column label="任务编号" prop="task_num" width="130" />
      <el-table-column label="任务名称" prop="task_name" min-width="180" />

      <el-table-column label="计划执行时间" width="170">
        <template slot-scope="scope">
          {{ formatTimeStr(scope.row.run_time) }}
        </template>
      </el-table-column>

      <el-table-column label="任务状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="getStatusType(scope.row.status)">
            {{ getStatusText(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column label="执行结果" width="110" align="center">
        <template slot-scope="scope">
          <el-tag :type="getResultType(scope.row.act_result)">
            {{ getResultText(scope.row.act_result) }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column
        label="执行参数"
        prop="params"
        width="200"
        show-overflow-tooltip
      />
      <el-table-column label="创建时间" prop="created_at" width="170" />
      <el-table-column label="更新时间" prop="updated_at" width="170" />

      <el-table-column label="操作" width="90" align="center">
        <template slot-scope="scope">
          <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.row)">
            编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 移动端卡片 -->
    <div class="mobile-card-list">
      <div class="mobile-card" v-for="item in tableData" :key="item.id">
        <div class="card-top">
          <div class="label">编号：{{ item.task_num }}</div>
          <el-tag :type="getStatusType(item.status)" size="mini">
            {{ getStatusText(item.status) }}
          </el-tag>
        </div>
        <div class="card-body">
          <div><span>任务名称：</span>{{ item.task_name }}</div>
          <div><span>计划执行：</span>{{ formatTimeStr(item.run_time) }}</div>
          <div>
            <span>执行结果：</span>
            <el-tag :type="getResultType(item.act_result)" size="mini">
              {{ getResultText(item.act_result) }}
            </el-tag>
          </div>
          <div><span>执行参数：</span>{{ item.params || "-" }}</div>
          <div><span>创建时间：</span>{{ item.created_at }}</div>
        </div>
        <div class="card-footer">
          <el-button type="primary" plain size="mini" icon="el-icon-edit" @click.stop="handleEdit(item)">
            编辑
          </el-button>
        </div>
      </div>
    </div>

    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchParams.page"
      :page-size="searchParams.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageInfo.total"
      style="margin-top: 20px; text-align: right"
            pager-count="2"
            small
    />

    <!-- ====================== PC 独立弹窗 ====================== -->
    <el-dialog
      title="修改执行状态"
      :visible.sync="pcDialogVisible"
      width="550px"
      class="pc-dialog"
      @close="resetEditForm"
      append-to-body
    >
      <el-form :model="editForm" label-width="110px">
        <el-form-item label="执行记录ID">
          <el-input v-model="editForm.id" disabled />
        </el-form-item>
        <el-form-item label="任务名称">
          <el-input v-model="editForm.task_name" disabled />
        </el-form-item>

        <el-form-item label="计划执行时间">
          <el-date-picker
            v-model="editForm.run_time"
            type="datetime"
            placeholder="选择时间"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
          />
        </el-form-item>

        <el-form-item label="任务状态">
          <el-select v-model="editForm.status" placeholder="请选择">
            <el-option label="待执行" :value="0" />
            <el-option label="执行中" :value="1" />
            <el-option label="已结束" :value="2" />
          </el-select>
        </el-form-item>

        <el-form-item label="执行结果">
          <el-select v-model="editForm.act_result" placeholder="请选择">
            <el-option label="待执行" :value="0" />
            <el-option label="成功" :value="1" />
            <el-option label="失败" :value="2" />
            <el-option label="超时失败" :value="3" />
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" style="text-align: right">
        <el-button @click="pcDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEdit">确认修改</el-button>
      </div>
    </el-dialog>

    <!-- ====================== 移动端独立弹窗 ====================== -->
    <el-dialog
      title="修改执行状态"
      :visible.sync="mobileDialogVisible"
      width="92%"
      custom-class="mobile-dialog"
      @close="resetEditForm"
      append-to-body
    >
      <el-form :model="editForm" label-width="80px" size="small">
        <el-form-item label="记录ID">
          <el-input v-model="editForm.id" disabled />
        </el-form-item>
        <el-form-item label="任务名称">
          <el-input v-model="editForm.task_name" disabled />
        </el-form-item>

        <el-form-item label="执行时间">
          <el-date-picker
            v-model="editForm.run_time"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择时间"
            style="width: 100%"
          />
        </el-form-item>

        <el-form-item label="状态">
          <el-select v-model="editForm.status" style="width: 100%">
            <el-option label="待执行" :value="0" />
            <el-option label="执行中" :value="1" />
            <el-option label="已结束" :value="2" />
          </el-select>
        </el-form-item>

        <el-form-item label="结果">
          <el-select v-model="editForm.act_result" style="width: 100%">
            <el-option label="待执行" :value="0" />
            <el-option label="成功" :value="1" />
            <el-option label="失败" :value="2" />
            <el-option label="超时失败" :value="3" />
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" style="text-align: right; margin-top: 10px">
        <el-button size="small" @click="mobileDialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" @click="submitEdit">确认修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "../../api/api.js";

export default {
  name: "TaskRunTable",
  data() {
    return {
      loading: false,
      tableData: [],
      taskList: [], // 任务下拉列表数据
      pageInfo: { total: 0 },
      searchParams: {
        page: 1,
        page_size: 10,
        task_num: "",
      },

      editForm: {
        id: "",
        run_time: "",
        status: 0,
        act_result: 0,
      },

      pcDialogVisible: false,
      mobileDialogVisible: false,
    };
  },
  created() {
    this.getRunTaskList();
  },
  methods: {
    getRunTaskList() {
      this.loading = true;
      api.task
        .runTaskList({ params: this.searchParams })
        .then((res) => {
          if (res.data.code == 1000) {
            this.tableData = res.data.data.data;
            this.pageInfo.total = res.data.data.total;
            this.taskList = res.data.data.task_list || []; // 赋值下拉数据
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 打开编辑（自动适配设备）
    handleEdit(row) {
      let runTime = row.run_time;
      if (runTime && !isNaN(Number(runTime))) {
        runTime = this.formatTimeStr(runTime);
      }

      this.editForm = {
        ...row,
        run_time: runTime,
      };

      if (document.body.clientWidth <= 768) {
        this.mobileDialogVisible = true;
      } else {
        this.pcDialogVisible = true;
      }
    },

    // 提交修改（时间传字符串，不戳时间戳）
    submitEdit() {
      this.loading = true;
      const params = {
        run_task_id: this.editForm.id,
        run_time: this.editForm.run_time, // 直接传 yyyy-MM-dd HH:mm:ss
        status: this.editForm.status,
        act_result: this.editForm.act_result,
      };

      api.task
        .status(params)
        .then((res) => {
          if (res.data.code == 1000) {
            this.getRunTaskList();
            this.pcDialogVisible = false;
            this.mobileDialogVisible = false;
          } else {
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    resetEditForm() {
      this.editForm = { id: "", run_time: "", status: 0, act_result: 0 };
    },

    // 时间格式化：时间戳 → 字符串
    formatTimeStr(timestamp) {
      if (!timestamp || timestamp == 0) return "-";
      let date = new Date(timestamp * 1000);
      let y = date.getFullYear();
      let m = (date.getMonth() + 1).toString().padStart(2, "0");
      let d = date.getDate().toString().padStart(2, "0");
      let hh = date.getHours().toString().padStart(2, "0");
      let mm = date.getMinutes().toString().padStart(2, "0");
      let ss = date.getSeconds().toString().padStart(2, "0");
      return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
    },

    // 状态
    getStatusText(s) {
      return { 0: "待执行", 1: "执行中", 2: "已结束" }[s] || s;
    },
    getStatusType(s) {
      return { 0: "info", 1: "warning", 2: "success" }[s] || "info";
    },

    // 执行结果（0=待执行 回显正确）
    getResultText(r) {
      return {
        0: "待执行",
        1: "成功",
        2: "失败",
        3: "超时失败",
      }[r] || r;
    },
    getResultType(r) {
      return {
        0: "info",
        1: "success",
        2: "danger",
        3: "warning",
      }[r] || "info";
    },

    resetSearch() {
      this.searchParams.task_num = "";
      this.getRunTaskList();
    },

    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getRunTaskList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getRunTaskList();
    },
  },
};
</script>

<style scoped>
.task-run-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.pc-table {
  display: table;
  width: 100% !important;
  table-layout: fixed;
}

/* 移动端卡片 */
.mobile-card-list {
  display: none;
  flex-direction: column;
  gap: 10px;
  margin-top: 15px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.card-top .label {
  font-size: 15px;
  font-weight: 500;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.8;
}
.card-body span {
  color: #999;
}
.card-footer {
  margin-top: 10px;
  text-align: right;
}

/* 响应式 */
@media (max-width: 768px) {
  .task-run-table-container {
    padding: 10px;
  }
  .pc-table {
    display: none !important;
  }
  .pc-dialog {
    display: none !important;
  }
  .mobile-card-list {
    display: flex !important;
  }
}
</style>

<style>
.mobile-dialog {
  border-radius: 16px !important;
}
.mobile-dialog .el-dialog__body {
  padding: 10px 15px !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/operate/run_task.vue